import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

export const queryKeys = {
  me: ['auth', 'me'] as const,
  escolas: ['auth', 'escolas'] as const,
  escolasList: ['escolas', 'list'] as const,
  escolaDetail: (id: number) => ['escolas', 'detail', id] as const,
  turmasList: ['turmas', 'list'] as const,
  turmaDetail: (id: number) => ['turmas', 'detail', id] as const,
  alunosList: ['alunos', 'list'] as const,
  alunoDetail: (id: number) => ['alunos', 'detail', id] as const,
  responsaveisList: ['responsaveis', 'list'] as const,
  responsavelDetail: (id: number) => ['responsaveis', 'detail', id] as const,
  colaboradoresList: ['colaboradores', 'list'] as const,
  colaboradorDetail: (id: number) => ['colaboradores', 'detail', id] as const,
  cargosList: ['cargos', 'list'] as const,
  cargoDetail: (id: number) => ['cargos', 'detail', id] as const,
  perfisList: ['perfis', 'list'] as const,
  perfilDetail: (id: number) => ['perfis', 'detail', id] as const,
  perfisLookup: ['perfis', 'lookup'] as const,
  layoutsEmailCatalogo: ['layouts-email', 'catalogo'] as const,
  layoutEmailDetail: (id: number) => ['layouts-email', 'detail', id] as const,
  layoutEmailPadrao: (chave: string) => ['layouts-email', 'padrao', chave] as const,
  classificacoesList: ['classificacoes', 'list'] as const,
  classificacaoDetail: (id: number) => ['classificacoes', 'detail', id] as const,
  pratosList: ['pratos', 'list'] as const,
  pratoDetail: (id: number) => ['pratos', 'detail', id] as const,
  cardapioSemana: (de: string, ate: string, idTurma: number | null) =>
    ['cardapios', 'semana', de, ate, idTurma] as const,
  atividadesArvore: (idEscola: number | null) => ['atividades', 'arvore', idEscola] as const,
  atividadesDia: (data: string, tipo: string, idTurma?: number, idAluno?: number) =>
    ['atividades', 'dia', data, tipo, idTurma ?? null, idAluno ?? null] as const,
  dashboardSnapshot: ['dashboard', 'snapshot'] as const,
  dashboardFiltrado: (de: string, ate: string, idTurma: number | null) =>
    ['dashboard', 'filtrado', de, ate, idTurma] as const,
  publicacaoHistorico: (id: number) => ['publicacoes', 'historico', id] as const,
  publicacaoComentarios: (id: number) => ['publicacoes', 'comentarios', id] as const,
  publicacaoCurtidas: (id: number) => ['publicacoes', 'curtidas', id] as const,
  auditoriaList: (params: Record<string, unknown>) => ['auditoria', 'list', params] as const,
  atasList: (params: Record<string, unknown>) => ['atas', 'list', params] as const,
  ataDetail: (id: number) => ['atas', 'detail', id] as const,
  ataTranscricao: (id: number) => ['atas', 'transcricao', id] as const,
  ataUltimaGravacao: (idAta: number) => ['atas', 'gravacao', idAta, 'ultima'] as const,
  ataConfiguracao: ['atas', 'configuracao'] as const,
  ataGeracaoIa: (idAta: number, idGeracao: number) =>
    ['atas', 'geracao-ia', idAta, idGeracao] as const,
  relogioEscola: ['sistema', 'relogio'] as const,
  versaoApi: ['sistema', 'versao'] as const,
};
